import strugglePNG from '~/assets/images/communication/struggle.png'
import struggleWEBP from '~/assets/images/communication/struggle.webp'
import InfoPage from '~/pages/communication/libs/InfoPage'
import { TPageProps } from '~/shared/types/commonTypes'

const StruggleCommunication = (props: TPageProps) => (
  <InfoPage
    {...props}
    question="7 in 10 people struggle with the same thing"
    titleI18nKey="onboarding.communicationStruggle.title"
    subtitleI18nKey="onboarding.communicationStruggle.subtitle"
    imagePng={strugglePNG}
    imageWebp={struggleWEBP}
    imageAlt="7 in 10 people struggle with the same thing"
    contentGap={24}
  />
)

export default StruggleCommunication
